import axios from 'axios';
import { sessionLifecycle, sessionToken, tokenExpiresAt } from './session-lifecycle';

export function isSessionFailure(error, token) {
  const status = error.response && error.response.status;
  if (status === 401) return true;
  if (status !== 403) return false;
  const data = error.response.data || {};
  // A permission denial is not a session failure. Never infer this from prose.
  return ['TOKEN_EXPIRED', 'SESSION_EXPIRED', 'INVALID_TOKEN', 'SESSION_REVOKED'].includes(data.code) ||
    (tokenExpiresAt(token) !== null && tokenExpiresAt(token) <= Date.now());
}

export function installSessionInterceptor(client, lifecycle = sessionLifecycle, getToken = sessionToken) {
  const pending = new Set();
  lifecycle.subscribe(() => {
    pending.forEach(source => source.cancel('Sessão encerrada'));
    pending.clear();
  });
  client.interceptors.request.use(config => {
    if (config.publicSessionRequest || (config.headers && config.headers['public-request'])) return config;
    if (config.sessionTokenAtRequest && config.sessionTokenAtRequest !== getToken()) {
      throw new axios.Cancel('Requisição de sessão anterior');
    }
    if (!lifecycle.check()) {
      lifecycle.expire();
      throw new axios.Cancel('Sessão encerrada');
    }
    const target = new URL(config.url, config.baseURL || window.location.origin);
    config.sessionOwnedOrigin = target.origin === new URL(config.baseURL || window.location.origin).origin;
    config.sessionTokenAtRequest = getToken();
    const source = axios.CancelToken.source();
    if (config.cancelToken) config.cancelToken.promise.then(reason => source.cancel(reason.message));
    config.cancelToken = source.token;
    config.sessionCancelSource = source;
    pending.add(source);
    source.token.promise.then(() => pending.delete(source));
    return config;
  });
  const finish = config => { if (config) pending.delete(config.sessionCancelSource); };
  client.interceptors.response.use(response => { finish(response.config); return response; }, error => {
    const config = error.config;
    finish(config);
    if (config && config.sessionOwnedOrigin && config.sessionTokenAtRequest && isSessionFailure(error, config.sessionTokenAtRequest)) {
      lifecycle.expire(config.sessionTokenAtRequest);
    }
    return Promise.reject(error);
  });
}
